// extracted by extract-css-chunks-webpack-plugin
module.exports = {"page-container":"app__page-container___2Y47F","pageContainer":"app__page-container___2Y47F","page-title":"app__page-title___1ykDn","pageTitle":"app__page-title___1ykDn","page-description":"app__page-description___3nyFC","pageDescription":"app__page-description___3nyFC"};
    if(module.hot) {
      // 1773710387657
      var cssReload = require("../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  